// 通知相关 API 服务
import { apiClient, API_ENDPOINTS } from './config.js';

// 通知服务类
class NoticeService {
  
  // 获取所有通知
  async getAll(limit = null) {
    try {
      const url = limit ? `${API_ENDPOINTS.NOTICES.LIST}?limit=${limit}` : API_ENDPOINTS.NOTICES.LIST;
      const response = await apiClient.get(url);
      return response.notices;
    } catch (error) {
      console.error('Get notices failed:', error);
      throw error;
    }
  }
  
  // 获取单个通知
  async getById(id) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.NOTICES.GET(id));
      return response.notice;
    } catch (error) {
      console.error('Get notice failed:', error);
      throw error;
    }
  }
  
  // 创建通知
  async create(noticeData) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.NOTICES.CREATE, {
        title: noticeData.title,
        content: noticeData.content,
        date: noticeData.date,
        isImportant: noticeData.isImportant || false,
        imageUrl: noticeData.imageUrl || ''
      });
      return response.notice;
    } catch (error) {
      console.error('Create notice failed:', error);
      throw error;
    }
  }
  
  // 更新通知
  async update(id, noticeData) {
    try {
      const response = await apiClient.put(API_ENDPOINTS.NOTICES.UPDATE(id), {
        title: noticeData.title,
        content: noticeData.content,
        date: noticeData.date,
        isImportant: noticeData.isImportant || false,
        imageUrl: noticeData.imageUrl || ''
      });
      return response.notice;
    } catch (error) {
      console.error('Update notice failed:', error);
      throw error;
    }
  }
  
  // 删除通知
  async delete(id) {
    try {
      const response = await apiClient.delete(API_ENDPOINTS.NOTICES.DELETE(id));
      return response;
    } catch (error) {
      console.error('Delete notice failed:', error);
      throw error;
    }
  }
  
  // 获取最新通知（首页用）
  async getLatest(limit = 3) {
    return this.getAll(limit);
  }
  
  // 上传图片
  async uploadImage(file) {
    try {
      const formData = new FormData();
      formData.append('image', file);
      
      const response = await apiClient.post(API_ENDPOINTS.UPLOAD, formData, true);
      return response.url;
    } catch (error) {
      console.error('Upload image failed:', error);
      throw error;
    }
  }
}

// 创建全局通知服务实例
export const noticeService = new NoticeService();

// 兼容 Firebase Firestore 的函数

// 模拟 collection 函数
export const collection = (db, collectionName) => {
  return { _collectionName: collectionName };
};

// 模拟 query 函数
export const query = (collectionRef, ...constraints) => {
  return { 
    _collectionName: collectionRef._collectionName,
    _constraints: constraints 
  };
};

// 模拟 orderBy 函数
export const orderBy = (field, direction = 'asc') => {
  return { _type: 'orderBy', field, direction };
};

// 模拟 limit 函数
export const limit = (limitValue) => {
  return { _type: 'limit', value: limitValue };
};

// 模拟 getDocs 函数
export const getDocs = async (queryRef) => {
  try {
    let notices;
    
    if (queryRef._collectionName === 'notices') {
      // 检查是否有 limit 约束
      const limitConstraint = queryRef._constraints?.find(c => c._type === 'limit');
      const limitValue = limitConstraint ? limitConstraint.value : null;
      
      notices = await noticeService.getAll(limitValue);
    } else {
      throw new Error(`Unsupported collection: ${queryRef._collectionName}`);
    }
    
    // 模拟 Firebase 的 QuerySnapshot 结构
    return {
      docs: notices.map(notice => ({
        id: notice.id,
        data: () => notice
      })),
      empty: notices.length === 0
    };
  } catch (error) {
    console.error('getDocs failed:', error);
    throw error;
  }
};

// 模拟 addDoc 函数
export const addDoc = async (collectionRef, data) => {
  try {
    if (collectionRef._collectionName === 'notices') {
      const notice = await noticeService.create(data);
      return { id: notice.id };
    } else {
      throw new Error(`Unsupported collection: ${collectionRef._collectionName}`);
    }
  } catch (error) {
    console.error('addDoc failed:', error);
    throw error;
  }
};

// 模拟 doc 函数
export const doc = (db, collectionName, docId) => {
  return { 
    _collectionName: collectionName,
    _docId: docId 
  };
};

// 模拟 updateDoc 函数
export const updateDoc = async (docRef, data) => {
  try {
    if (docRef._collectionName === 'notices') {
      await noticeService.update(docRef._docId, data);
    } else {
      throw new Error(`Unsupported collection: ${docRef._collectionName}`);
    }
  } catch (error) {
    console.error('updateDoc failed:', error);
    throw error;
  }
};

// 模拟 deleteDoc 函数
export const deleteDoc = async (docRef) => {
  try {
    if (docRef._collectionName === 'notices') {
      await noticeService.delete(docRef._docId);
    } else {
      throw new Error(`Unsupported collection: ${docRef._collectionName}`);
    }
  } catch (error) {
    console.error('deleteDoc failed:', error);
    throw error;
  }
};

// 模拟 serverTimestamp 函数
export const serverTimestamp = () => {
  return new Date().toISOString();
};

export default noticeService; 